module.exports = __webpack_public_path__ + "static/javascript_fullstack_bootcamp-13-249fbfa8b04866babbd3c0187238743d.jpg";